<template>
  <div class="container" style="padding: 0px; padding-bottom: 60px">
    <!--  <h2 style="padding-bottom: 20px;padding-top: 35px;">Experience</h2> -->

    <div
      class="section-title text-center light"
      style="color: black; margin-bottom: 20px"
    >
      <!--             <h6>Our</h6> -->
      <h2>Our Promotions</h2>
    </div>

    <carousel 
      :dots="false"
      :autoplay="true"
      :loop="true"
      :items="1"
      :nav="false"
      :margin="10"
      :rewind="true"
      :autoplayTimeout="2000"
      :smartSpeed="800" v-if="promo"
    >
    <!-- {{ promo }} -->
    <div v-for="item in promo" :key="item.pro_name">
      <img
        :src='uploads+item.pro_name'
        alt="1000X1000"
        style="border-radius: 15px !important"
      />
    </div>
    </carousel>
  </div>
</template>
<script>
import axios from "axios";
import { URL,UPLOADS } from "@/conf";
import carousel from "vue-owl-carousel/src/Carousel";
export default {
  data:()=>({
    loaded:false,
    promo:null,
    uploads:UPLOADS
  }),
  components: { carousel },
  methods:{
    async getPromo() {  
      axios.get(URL + 'promo')
        .then(response => {
          this.loaded = true;
          const resultarr = response.data.response.result;
          this.promo = resultarr;
        });
    },
  },
  mounted(){
this.getPromo();
  }
};
</script>
